import "./templateone.css";
import "../style.css";
import {
  React,
  ArrowBackIosNewIcon,
  ReactPlayer,
  useLocation,
  useNavigate,
} from "../../../Libraries/Post/LayoutPreview/index";

const TemplateOne = () => {
  const location = useLocation();
  const navigate = useNavigate();
  console.log("in temp 1", "= "+ location.state.media.finalfile.txt_media_file_type);

  const handleNavigate = () => {
    if (location.state.from === "editpost") {
      navigate("/editPost", { state: location.state, replace: true });
    } else if (location.state.from === "addnewpost") {
      navigate("/addnewpost", { state: location.state, replace: true });
    }
    else{
       if(location.state.media.ser_collection_id){
          console.log("Testing");
          navigate("/groupposts", {
            state: location.state.currentScreen,
            replace: true,
          });
        }else{
          navigate("/posts", {
            state: location.state.currentScreen,
            replace: true,
          });
        }
    }
  };



  return (
    <div className="container d-flex justify-content-center align-items-center">
      <div className="tele">
        <div className="screen">
          <div className="l1page">
            <ArrowBackIosNewIcon
              id="button"
              fontSize="30px"
              style={{
                position: "absolute",
                zIndex: 10,
                fontSize: "2em",
                color: "red",
              }}
              onClick={handleNavigate}
            />

            {/* {location.state?.finalfile?.type === "Image" ? ( */}
            {location.state?.media.finalfile?.txt_media_file_type === "Image" ? (
              <div className="l1photo">
                <img
                  // src={location.state?.finalfile?.link}
                  src={location.state?.media.finalfile?.txt_media_streaming_link}
                  alt="img or video"
                  width="100%"
                  height="100%"
                />
              </div>
            ) : location.state?.media.finalfile?.txt_media_file_type === "Video" ? (
              <div className="l1photo">
                <ReactPlayer
                  url={location.state?.media.finalfile?.txt_media_streaming_link}
                  controls
                  loop={true}
                  className="player"
                  height="100%"
                  width="100%"
                  playing={true}
                  playsInline
                />
              </div>
            ) : location.state?.finalfile?.txt_media_file_type === "Widget" ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: location.state?.finalfile?.txt_media_streaming_link,
                }}
                style={{ height: "100%", width: "100%" }}
              />
            ) : null}
          </div>
        </div>

        <div className="standouter">
          <div className="stand"></div>
        </div>
      </div>
    </div>
  );
};

export default TemplateOne;
